export default {
  forgot_password: {
    title: '패스워드 초기화',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: '패스워드를 분실하신 분에게',
    password_reset_text: '이메일 주소를 입력&송신 버튼을 누르면 확인 메일이 도착하므로 패스워드 초기화 처리를 해 주세요.',
    submit: '송신하기',
    mail_address: '이메일 주소를 입력해 주세요',
    input_label: '@:settings.user.email',
  },
}
